import type { Theme } from "@mui/material";
import { cssColorToArgb, isExcelRepresentableColor } from "../../../../../downloads/weekStaffScheduleExport/render/colors";
import type { WeekStaffScheduleExportColors } from "../../../../../downloads/weekStaffScheduleExport/types";
import { INK, NEUTRAL, STATUS, STATUS_BADGE } from "../../../../../theme/tokens";

/**
 * Resolve the sheet's palette from the live theme.
 *
 * Colors have to be read here rather than in the builder: the brand purple is whatever the user
 * picked, so it only exists on the theme, and a spreadsheet needs a concrete ARGB value. The
 * scheduled/actual/time-off split mirrors the on-screen cards — brand purple for planned shifts,
 * green for worked ones, muted grey for time off.
 */
export const buildWeekScheduleExportColors = (theme: Theme): WeekStaffScheduleExportColors => {
	const brandInk = theme.palette.primary[700];
	const brandWash = theme.palette.primary[50];

	return {
		// DEFAULT: a custom theme color could in principle arrive in a form a spreadsheet can't express
		// (a CSS variable or an alpha blend); fall back to the static brand hex so the sheet still
		// reads as ours instead of throwing mid-export.
		scheduledFontArgb: cssColorToArgb(isExcelRepresentableColor(brandInk) ? brandInk : STATUS_BADGE.BRAND_FALLBACK_HEX),
		scheduledFillArgb: cssColorToArgb(isExcelRepresentableColor(brandWash) ? brandWash : NEUTRAL[100]),
		actualFontArgb: cssColorToArgb(STATUS.SUCCESS.main),
		actualFillArgb: cssColorToArgb(STATUS.SUCCESS.light),
		timeOffFontArgb: cssColorToArgb(INK.SECONDARY),
		dateRowFontArgb: cssColorToArgb(INK.SECONDARY),
		subtitleFontArgb: cssColorToArgb(INK.MUTED),
	};
};
